"use strict";

exports.VerificationURI = exports.REFERRAL_API_KEY = exports.REFERRAL_API_BASE_URL = exports.OVERRIDE_PAYMENT_BYPASS = exports.NATIVE_TOKEN_PLACEHOLDER_ADDRESS = exports.FEE_PROPORTION = exports.FEE_MIN_USD = exports.ENVIRONMENT = exports.DEXSCREENER_API_BASE_URL = void 0;
// theses constants are replaced at build time
const ENVIRONMENT = exports.ENVIRONMENT = "dev";
const VerificationURI = exports.VerificationURI = {
  US: "https://verification-dev-ca.presend.io",
  CA: "https://verification-dev-us.presend.io"
};
const REFERRAL_API_BASE_URL = exports.REFERRAL_API_BASE_URL = "FROM_SECRET";
const REFERRAL_API_KEY = exports.REFERRAL_API_KEY = "FROM_SECRET";
const OVERRIDE_PAYMENT_BYPASS = exports.OVERRIDE_PAYMENT_BYPASS = "false" === 'true';
const DEXSCREENER_API_BASE_URL = exports.DEXSCREENER_API_BASE_URL = 'https://api.dexscreener.com/latest';
const FEE_PROPORTION = exports.FEE_PROPORTION = 0.002;
const FEE_MIN_USD = exports.FEE_MIN_USD = 1;
const NATIVE_TOKEN_PLACEHOLDER_ADDRESS = exports.NATIVE_TOKEN_PLACEHOLDER_ADDRESS = '0x000000000000000000000000000000000000dEaD';